const LINK_PREFIX = '#modal-';

let scrollPosition = 0;

/**
 * Opens a modal dialog and prevents background scrolling
 */
export const openModal = (modalEl) => {
    if (modalEl) {
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';

        modalEl.showModal();
        modalEl.scrollTo(0, 0);
        document.body.classList.add('no-scroll');
        if (modalEl.querySelector('.ra__player')) {
            window.dispatchEvent(new Event('resize'));
        }
    }
};

export const handleModalClose = () => {
    window.dispatchEvent(new CustomEvent('pauseVideo'));

    if (window.vidyardEmbed) {
        const { players } = window.VidyardV4;
        if (players && players[0]) {
            players[0].pause();
        }
    }

    const scrollY = scrollPosition;

    const htmlElement = document.documentElement;
    const originalScrollBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = 'auto';

    document.body.classList.remove('no-scroll');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';

    window.scrollTo(0, scrollY);

    htmlElement.style.scrollBehavior = originalScrollBehavior;
};

/**
 * @param {MouseEvent} ev
 */
const handleModalLinkClick = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    const href = ev.currentTarget.getAttribute('href');
    const modalEl = document.querySelector(`dialog${href}`);

    if (modalEl) {
        requestAnimationFrame(() => {
            openModal(modalEl);
        });
    }
};

const handleModalInternalLinkClick = (modalEl) => {
    modalEl.close();
};

const linkEls = document.querySelectorAll(`[href^="${LINK_PREFIX}"]`);
linkEls.forEach((linkEl) => {
    linkEl.addEventListener('click', handleModalLinkClick);
});

const modalEls = document.querySelectorAll('dialog:is(.fx-modal, .px-modal, .ra-modal, .ss-modal)');
modalEls.forEach((modalEl) => {
    modalEl.addEventListener('close', handleModalClose);

    // Close Button click to close modal
    const closeBtn = modalEl.querySelector('.modal__close-button');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => modalEl.close());
    }

    // Backdrop click to close modal
    modalEl.addEventListener('click', (event) => {
        const rect = modalEl.getBoundingClientRect();
        const clickedInDialog = event.clientX >= rect.left
            && event.clientX <= rect.right
            && event.clientY >= rect.top
            && event.clientY <= rect.bottom;

        if (!clickedInDialog) {
            modalEl.close();
        }
    });

    // Internal modal link click to close modal
    modalEl.querySelectorAll('a').forEach((linkEl) => {
        linkEl.addEventListener('click', () => handleModalInternalLinkClick(modalEl));
    });
});
